import React, { FC } from 'react';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';

const styles = ({
  custom: {
    palette: { colorSupportSnow },
  },
  spacing: { unit },
  zIndex,
}: Theme) =>
  createStyles({
    root: {
      backgroundColor: colorSupportSnow,
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      height: '100%',
      width: '100%',
    },
    poweredByLuma: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      padding: `0 ${unit}px`,
      fontSize: '12px',
      zIndex: zIndex.appBar,
    },
    lumalogo: {
      height: '12px',
      marginLeft: `${unit / 2}px`,
    },
  });

interface EmbedorProps extends WithStyles<typeof styles> {}

const EmbedorWrapper: FC<EmbedorProps> = ({ classes, children }) => (
  <div className={classes.root}>
    {children}
    <div className={classes.poweredByLuma}>
      Powered by <img className={classes.lumalogo} src="/lumalogo.png" alt="Luma" />
    </div>
  </div>
);

export default withStyles(styles)(EmbedorWrapper);
